module.exports = __webpack_public_path__ + "static/media/sol.80105894.svg";